'use client';

import { useTranslation } from 'react-i18next';
import { IconComponent } from '@/components/IconComponent';

interface SignOutButtonProps {
  onSignOut: () => void;
}

export const SignOutButton = ({ onSignOut }: SignOutButtonProps) => {
  const { t } = useTranslation();

  return (
    <button data-testid="mobile-logout-button" onClick={onSignOut}>
      <IconComponent name="signout" />
      {t('button.signOut')}
    </button>
  );
};
